var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "#F4F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 17H26V14C26 10.691 23.309 8 20 8C16.691 8 14 10.691 14 14V17H13.25C12.01 17 11 18.009 11 19.25V29.75C11 30.991 12.01 32 13.25 32H26.75C27.99 32 29 30.991 29 29.75V19.25C29 18.009 27.99 17 26.75 17ZM16 14C16 11.794 17.794 10 20 10C22.206 10 24 11.794 24 14V17H16V14ZM21 24.722V27C21 27.552 20.553 28 20 28C19.447 28 19 27.552 19 27V24.722C18.405 24.375 18 23.737 18 23C18 21.897 18.897 21 20 21C21.103 21 22 21.897 22 23C22 23.737 21.595 24.375 21 24.722Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.ee4f3e4449d2ab92d186f59e7969e13f.svg";
export { ForwardRef as ReactComponent };